










import {Component, Prop, Vue} from 'vue-property-decorator'
import {Alignment, Fit, Layout, Rive, RuntimeLoader} from '@rive-app/webgl2'
import {EnvHelper} from '@/helpers/EnvHelper'

RuntimeLoader.setWasmUrl(`${EnvHelper.BASE_URL}rive.wasm`)

const FITS: Record<string, Fit> = {contain: Fit.Contain, cover: Fit.Cover}
const ALIGNMENTS: Record<string, Alignment> = {
  center: Alignment.Center,
  topCenter: Alignment.TopCenter,
}

@Component
export default class GasbotRiveAnimation extends Vue {
  @Prop({type: String, default: 'Appearing'}) animation!: string
  @Prop({type: Boolean, default: true}) autoplay!: boolean
  @Prop({type: String, default: 'contain'}) fit!: string
  @Prop({type: String, default: 'center'}) alignment!: string
  @Prop({type: Boolean, default: false}) playOnVisible!: boolean

  private rive?: Rive
  private resizeObserver?: ResizeObserver
  private visibilityObserver?: IntersectionObserver

  $refs!: {canvas: HTMLCanvasElement}

  mounted() {
    this.rive = new Rive({
      src: `${EnvHelper.BASE_URL}gasbot.riv`,
      canvas: this.$refs.canvas,
      animations: this.animation,
      autoplay: this.autoplay,
      layout: new Layout({
        fit: FITS[this.fit],
        alignment: ALIGNMENTS[this.alignment],
      }),
      onLoad: () => {
        this.rive?.resizeDrawingSurfaceToCanvas()
        if (this.playOnVisible) this.observeVisibility()
      },
    })

    this.resizeObserver = new ResizeObserver(() =>
      this.rive?.resizeDrawingSurfaceToCanvas()
    )
    this.resizeObserver.observe(this.$refs.canvas)
  }

  play() {
    if (!this.rive) return

    this.rive.scrub(this.animation, 0)
    this.rive.play(this.animation)
  }

  private observeVisibility() {
    this.visibilityObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return

      this.play()
      this.visibilityObserver?.disconnect()
      this.visibilityObserver = undefined
    })
    this.visibilityObserver.observe(this.$refs.canvas)
  }

  beforeDestroy() {
    this.resizeObserver?.disconnect()
    this.visibilityObserver?.disconnect()
    this.rive?.cleanup()
  }
}
